import { BariPostNurseSpecialistFollowUpBeoordelingEnVervolgEdit } from './BariPostNurseSpecialistFollowUpBeoordelingEnVervolgEdit';
import { BariPostNurseSpecialistFollowUpComorbiditeitenEdit } from './BariPostNurseSpecialistFollowUpComorbiditeitenEdit';
import { BariPostNurseSpecialistFollowUpLeefstijlEnMedicatieEdit } from './BariPostNurseSpecialistFollowUpLeefstijlEnMedicatieEdit';

export function BariPostNurseSpecialistFollowUpEdit(): JSX.Element {
    return (
        <>
            <BariPostNurseSpecialistFollowUpLeefstijlEnMedicatieEdit />
            <BariPostNurseSpecialistFollowUpComorbiditeitenEdit />
            <BariPostNurseSpecialistFollowUpBeoordelingEnVervolgEdit />
        </>
    );
}
